// app/javascript/controllers/phone_revealer_controller.js
// SIMPLE VERSION - No phone number ever exposed to browser

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["callText", "spinner"]
  static values = {
    url: String,
    businessProfileId: Number
  }

  connect() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }
  }

  async revealAndCall(event) {
    event.preventDefault()

    if (this.element.dataset.loading === "true") {
      return
    }

    try {
      this.showLoading()

      // ADD THIS: Include business_profile_id as query parameter for public profiles
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.append('business_profile_id', this.businessProfileIdValue)

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.getCSRFToken()
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.call_url) {
        // Track the click first
        this.trackPhoneClick()

        // Show success message
        this.showSuccess()

        // Redirect to the encrypted call URL - phone number stays on server
        window.location.href = data.call_url
      } else {
        throw new Error('Call URL not available')
      }

    } catch (error) {
      console.error('Call failed:', error.message)
      this.showError()
    } finally {
      this.hideLoading()
    }
  }

  showLoading() {
    this.element.dataset.loading = "true"
    this.element.classList.add("opacity-75", "cursor-wait")

    if (this.hasCallTextTarget) {
      this.callTextTarget.textContent = "Connecting..."
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }
  }

  hideLoading() {
    this.element.dataset.loading = "false"
    this.element.classList.remove("opacity-75", "cursor-wait")

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }
  }

  showSuccess() {
    if (this.hasCallTextTarget) {
      this.callTextTarget.textContent = "Calling..."

      setTimeout(() => {
        if (this.hasCallTextTarget) {
          this.callTextTarget.textContent = "Click to Call"
        }
      }, 3000)
    }
  }

  showError() {
    if (this.hasCallTextTarget) {
      this.callTextTarget.textContent = "Error - Try Again"
      this.element.classList.add("text-red-600")

      setTimeout(() => {
        if (this.hasCallTextTarget) {
          this.callTextTarget.textContent = "Click to Call"
          this.element.classList.remove("text-red-600")
        }
      }, 3000)
    }
  }

  // Simple tracking - match your existing PhoneClicksController format
  async trackPhoneClick() {
    try {
      // Use your existing phone_clicks endpoint with correct parameter names
      await fetch('/phone_clicks', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken()
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          business_profile_id: this.businessProfileIdValue,
          phone_number: "***-***-****" // Obfuscated for privacy
        })
      })
    } catch (error) {
      console.warn('Tracking failed:', error)
      // Don't prevent the call if tracking fails
    }
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }
}
